import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DialogModule } from "@progress/kendo-angular-dialog";
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { ToastrModule } from 'ngx-toastr';

import { SharedModule } from "@toolkit";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthenticationModule } from "./authentication/authentication.module";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { ShellModule } from "./shell/shell.module";
import { CoreModule } from "./core/core.module";
import { GlobalErrorHandler } from "./core/services/global-error-handler";

@NgModule({
    declarations: [
        AppComponent,
        PageNotFoundComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        CoreModule,
        SharedModule.forRoot(),
        ToastrModule.forRoot({
            closeButton: true,
            progressBar: true,
            positionClass: 'toast-bottom-right'
        }),
        LoadingBarModule,
        DialogModule,
        ShellModule,
        AuthenticationModule,
        AppRoutingModule
    ],
    providers:[
        { provide: ErrorHandler, useClass: GlobalErrorHandler }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
